import type { ConnectorDefinition } from "../types";

export const microsoftConnector: ConnectorDefinition = {
  id: "microsoft",
  name: "Microsoft 365",
  description:
    "Outlook email and calendar, scheduling, Teams meeting transcripts, and OneNote notebooks",
  icon: "microsoft",
  authType: "system",
  system: {
    token: { from: "login", loginProvider: "microsoft" },
    // Availability follows the Entra login session itself — if the user is
    // signed in, Graph is reachable — so there is no token to probe.
    resolvesToken: false,
  },
  dataProtection: {
    // Auth is the user's own M365 login (`authType: "system"`) — there is no
    // separate credential to repoint at a test tenant, so no sandbox.
    sandbox: { available: false },
    recovery: "vendor-trash",
    note:
      "Deleted Items and re-filing make mail writes recoverable. Unsubscribes " +
      "and calendar invites leave the tenant once sent.",
    reviewedAt: "2026-08-06",
  },
  isEnabled: () => true,
};
